let Glist = [
    {
        rid: 1,
        goods_id: 22,
        title: 'TSG S7005-2005 客运索道部件型式试验细则',
        public_time: '2022-12-30',
        act_time: '2023-07-01',
        gnum: 1, 
        price: '72.25',
        mprice: '83',
        price_type: '(会员价)',
        ctype: '结构化',
        class: 'colorblue',
        checked: true,
        goto: { path: '/shop/info', query: { id: 22 } },
        tags: [
            {id: 1, type: '', title: '国家标准'},
            {id: 2, type: 'success', title: '现行'},
            {id: 3, type: 'info', title: '电子版'},
            {id: 4, type: 'warning', title: '纸质版'},
            {id: 5, type: 'danger', title: '结构化'}
        ]
    }, {
        rid: 2,
        goods_id: 22,
        title: 'TSG S7005-2005 客运索道部件型式试验细则',
        public_time: '2022-12-30',
        act_time: '2023-07-01',
        gnum: 1, 
        price: '72.25',
        mprice: '83',
        price_type: '(会员价)',
        ctype: '纸质版',
        class: 'colorred',
        checked: true,
        goto: { path: '/shop/info', query: { id: 22 } },
        tags: [
            {id: 1, type: '', title: '国家标准'},
            {id: 2, type: 'success', title: '现行'},
            {id: 3, type: 'info', title: '电子版'},
            {id: 4, type: 'warning', title: '纸质版'},
            {id: 5, type: 'danger', title: '结构化'}
        ]
    }, {
        rid: 3,
        goods_id: 22,
        title: 'TSG S7005-2005 客运索道部件型式试验细则',
        public_time: '2022-12-30',
        act_time: '2023-07-01',
        gnum: 1, 
        price: '72.25',
        mprice: '83',
        price_type: '(会员价)',
        ctype: '电子版',
        class: 'colorgreen',
        checked: true,
        goto: { path: '/shop/info', query: { id: 22 } },
        tags: [
            {id: 1, type: '', title: '国家标准'},
            {id: 2, type: 'success', title: '现行'},
            {id: 3, type: 'info', title: '电子版'},
            {id: 4, type: 'warning', title: '纸质版'},
            {id: 5, type: 'danger', title: '结构化'}
        ]
    }
]

// Glist = []

export default Glist